var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74996 2.75H19.25C20.2625 2.75 21.0833 3.57081 21.0833 4.58333V17.4167C21.0833 18.4292 20.2625 19.25 19.25 19.25H2.74996C1.73744 19.25 0.916626 18.4292 0.916626 17.4167V4.58333C0.916626 3.57081 1.73744 2.75 2.74996 2.75ZM2.74996 4.58333V17.4167H19.25V4.58333H2.74996ZM6.41663 15.5833H8.24996V10.0833H6.41663V15.5833ZM11.9166 15.5833H10.0833V6.41667H11.9166V15.5833ZM13.75 15.5833H15.5833V9.16667H13.75V15.5833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.9b772e517cb0097115e60f01e43213e9.svg";
export { ForwardRef as ReactComponent };